import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CardOpenpayService } from 'src/app/card-payment/service/card-openpay.service';
import { ValidateOpenPayRequestDTO } from 'src/app/card-payment/service/PaymentOpenPayDTO';
import { LoaderPageService } from 'src/app/loaderPage/service/loader-page.service';
import { EnclosuresService } from 'src/app/enclosures/services/enclosures.service';
import { BusByTicketResponseDTO } from 'src/app/data/dto/EnclosuresDTO';
import { getAppTexts } from 'src/app/shared/i18n/app-text';
import { LanguageService } from 'src/app/shared/services/language.service';

declare global {
  interface Window {
    FlutterChannel: any;
  }
}

@Component({
  selector: 'app-payment-success-openpay',
  templateUrl: './payment-success-openpay.component.html',
  styleUrls: ['./payment-success-openpay.component.scss'],
})
export class PaymentSuccessOpenpayComponent implements OnInit {
  numReferencia: string = '';
  showSuccess = false;
  showError = false;
  getUrlNext: string = null;
  idTicket: number = null;
  busByTicketData: BusByTicketResponseDTO = null;

  constructor(
    private title: Title,
    private route: ActivatedRoute,
    private readonly cardOpenpayService: CardOpenpayService,
    private readonly enclosuresService: EnclosuresService,
    private loaderPageService: LoaderPageService,
    private router: Router,
    private readonly languageService: LanguageService,
  ) {
    this.title.setTitle(
      getAppTexts('paymentFlow', this.languageService.currentLang).pageTitleOpenpaySuccess,
    );
    this.route.queryParams.subscribe((params) => {
      const id = params['id'];
      this.numReferencia = id;
    });
  }

  ngOnInit(): void {
    this.validatePayment();
  }

  get texts() {
    return getAppTexts('paymentFlow', this.languageService.currentLang);
  }

  validatePayment() {
    this.loaderPageService.show();
    const request: ValidateOpenPayRequestDTO = {
      chargeId: this.numReferencia,
    };
    this.cardOpenpayService.validateOpenPay(request).subscribe({
      next: (data) => {
        this.loaderPageService.hide();
        this.showSuccess = true;
        this.getUrlNext = data.url;
        this.idTicket = data.idTicket ?? null;
      },
      error: (error) => {
        this.loaderPageService.hide();
        this.showSuccess = false;
        this.showError = true;
        console.log(error);
      },
    });
  }

  onHome() {
    if (window.FlutterChannel) {
      window.FlutterChannel.postMessage('PaymentFailed');
    } else {
      this.router.navigate(['/home']);
    }
  }

  onWalletQR() {
    if (window.FlutterChannel) {
      window.FlutterChannel.postMessage('PaymentSuccess');
      return;
    }
    if (this.idTicket) {
      this.getBusesByTicket(this.idTicket);
      return;
    }
    this.navigateToUrlNext();
  }

  getBusesByTicket(idTicket: number) {
    this.loaderPageService.show();
    this.enclosuresService.getBusesByTicket(idTicket).subscribe({
      next: (data) => {
        this.loaderPageService.hide();
        const response = data?.response;
        if (response && (response.isBusTicket || response.multipleAreaTicket)) {
          this.busByTicketData = data;
          this.router.navigate(['/buying-tickets'], {
            state: { busByTicketData: data },
          });
        } else {
          this.navigateToUrlNext();
        }
      },
      error: (error) => {
        this.loaderPageService.hide();
        console.log(error);
        this.navigateToUrlNext();
      },
    });
  }

  private navigateToUrlNext() {
    if (this.getUrlNext) {
      const tree = this.router.parseUrl(this.getUrlNext);
      this.router.navigateByUrl(tree);
    } else {
      this.router.navigate(['/home']);
    }
  }
}
